/**
 * Warstwa API: RAPORT PRACY ZDALNEJ — zmiany masowe konfiguracji (S13, 2026-09-14).
 *
 * Trasa backendu: `PUT api/hr/remote-reports/settings/bulk` (polityka `HrRemoteReports`).
 * Odczyt listy i zapis jednej osoby zostają w apiService.js (getRemoteReportSettings, updateRemoteReportSetting).
 *
 * Semantyka zmiany masowej (serwer):
 *   obowiazek: "bez-zmian" | "obowiazkowy" | "zwolniony"
 *   trybPol:   "bez-zmian" | "ustaw" (zastępuje listę) | "dopisz" (dokłada do obecnych) | "domyslne"
 *   pola:      etykiety dla "ustaw" / "dopisz"
 * Wszystko albo nic: jedna niepoprawna osoba lub etykieta = 400 i żadnego zapisu.
 *
 * Kontrakt: `attach(api)` zwraca nazwane metody doczepiane do wspólnego `apiService` (patrz attachApiModules).
 */
export function attach(api) {
    return {
        bulkUpdateRemoteReportSettings: ({ userIds, obowiazek, trybPol, pola }) =>
            api.put("/hr/remote-reports/settings/bulk", {
                userIds,
                obowiazek: obowiazek || "bez-zmian",
                trybPol: trybPol || "bez-zmian",
                pola: pola || [],
            }),
    };
}
